module.exports = __webpack_public_path__ + "h5/img/background.e2c90b57.jpg";